/* ==========================================================================
   XRED · Serious theme · global behaviours
   Ported from the static build's site.js + main.js (header parts) and wired
   to Shopify: header bar state, burger + phone menu, mega hover, search
   overlay + predictive search, phone tab bar, page transitions, the heat
   quiz, AJAX add to cart with the "Added" flash, quantity buttons,
   localization forms. Vanilla, no dependencies. Every init is guarded per
   element so it is safe to re-run on theme editor section loads.

   Exposes on window.XRED (set up in theme.liquid):
     formatMoney(cents), toast(text, opts), setCartCount(n),
     addToCart(formDataOrObject, opts), flash(button), init(root)
   ========================================================================== */
(function () {
  'use strict';

  var H = window.XRED = window.XRED || { routes: {}, strings: {} };
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ON = function (sw) { return root.getAttribute('data-xr-' + sw) !== 'off'; };

  /* ---------------------------------------------------------- utilities */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return k in map ? map[k] : m; }); }
  function lock(on) { document.body.classList.toggle('menu-locked', !!on); }

  function formatMoney(cents, format) {
    var fmt = format || H.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(num, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(placeholder), value;
    switch (m && m[1]) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  H.formatMoney = formatMoney;

  /* ------------------------------------------------------------- toast */
  var toastTimer;
  function toast(text, opts) {
    var el = $('#XrToast'); if (!el) return;
    opts = opts || {};
    var t = $('.xr-toast__text', el); if (t) t.textContent = text;
    var link = $('.xr-toast__link', el); if (link) link.hidden = !opts.link;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, opts.ms || 4200);
  }
  H.toast = toast;
  document.addEventListener('click', function (e) {
    if (e.target.closest('.xr-toast__close')) { var el = $('#XrToast'); if (el) el.hidden = true; }
  });

  /* -------------------------------------------------------- cart count */
  function setCartCount(n) {
    n = parseInt(n, 10) || 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  H.setCartCount = setCartCount;

  /* ---------------------------------------------------- "Added" flash */
  // Swaps the button label for "Added" for a beat, as the static build does.
  function flash(btn, text) {
    if (!btn || btn.classList.contains('btn--added')) return;
    var label = btn.querySelector('span') || btn, was = label.textContent;
    label.textContent = text || H.strings.addedToCart || 'Added';
    btn.classList.add('btn--added');
    setTimeout(function () { label.textContent = was; btn.classList.remove('btn--added'); }, 1400);
  }
  H.flash = flash;

  /* ------------------------------------------------ AJAX add to cart */
  // addToCart(FormData | {id, quantity, selling_plan, properties}, {button, quiet})
  // POSTs routes.cartAdd (asking for the drawer section when the cart is a
  // drawer), updates the count, dispatches xred:cart:added with the response,
  // flashes the originating button, and toasts with a cart link when the cart
  // is a page. Returns a promise of the response body.
  var drawerMode = H.cartType === 'drawer';
  function addToCart(data, opts) {
    opts = opts || {};
    var body, headers = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      if (drawerMode) data.append('sections', 'cart-drawer');
      body = data;
    } else {
      var o = data || {};
      var payload = { items: [{ id: parseInt(o.id, 10), quantity: parseInt(o.quantity, 10) || 1 }] };
      if (o.selling_plan) payload.items[0].selling_plan = o.selling_plan;
      if (o.properties) payload.items[0].properties = o.properties;
      if (drawerMode) payload.sections = 'cart-drawer';
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(payload);
    }
    var btn = opts.button;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }
    return fetch(H.routes.cartAdd || '/cart/add', { method: 'POST', body: body, headers: headers })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) || H.strings.cartError || 'Something went wrong';
          if (!opts.quiet) toast(msg);
          var err = new Error(msg); err.body = res.body; throw err;
        }
        // The add response carries the line, not the cart: ask the cart for its count.
        fetch((H.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCartCount(c.item_count); })
          .catch(function () {});
        if (btn) flash(btn);
        if (!drawerMode && !opts.quiet) toast(H.strings.addedToCart || 'Added to cart', { link: true });
        document.dispatchEvent(new CustomEvent('xred:cart:added', { detail: res.body }));
        return res.body;
      })
      .then(function (b) { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); } return b; },
            function (e) { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); } throw e; });
  }
  H.addToCart = addToCart;

  // Any [data-add] button adds its variant (data-add = variant id, optional
  // data-quantity) and flashes. From inside the quiz the quiz closes first.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]'); if (!b || e.defaultPrevented) return;
    if (b.getAttribute('aria-disabled') === 'true' || b.disabled) return;
    e.preventDefault();
    var quiz = b.closest('.quiz');
    if (quiz) { var qc = quiz.querySelector('[data-quiz-close]'); if (qc) qc.click(); }
    addToCart({ id: b.dataset.add, quantity: b.dataset.quantity || 1 }, { button: b }).catch(function () {});
  });

  // Product forms: <form data-product-form> submits through addToCart.
  function initProductForms(ctx) {
    $$('form[data-product-form]', ctx).forEach(function (form) {
      if (form.__xrInit) return; form.__xrInit = true;
      form.addEventListener('submit', function (e) {
        if (!window.fetch || form.hasAttribute('data-no-ajax')) return;
        e.preventDefault();
        var btn = $('[type="submit"]', form);
        var err = $('[data-form-error]', form);
        if (err) { err.hidden = true; err.textContent = ''; }
        addToCart(new FormData(form), { button: btn, quiet: !!err }).catch(function (x) {
          if (err) { err.textContent = x.message; err.hidden = false; }
        });
      });
    });
  }

  /* --------------------------------------------------------- quantity */
  // .qty groups with an <input>: − / + step the input and fire change. (The
  // cart drawer's <output> groups are handled by xred-cart-drawer.js.)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty [data-step], .quantity__button'); if (!btn || e.defaultPrevented) return;
    var wrap = btn.closest('.qty, .quantity'); var input = wrap && $('input', wrap); if (!input) return;
    var step = parseInt(input.step || '1', 10) || 1;
    var min = parseInt(input.min || '1', 10); if (isNaN(min)) min = 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var dir = btn.dataset.step === '-' || btn.dataset.dir === 'down' ? -1 : 1;
    var v = (parseInt(input.value || '0', 10) || 0) + dir * step;
    input.value = Math.max(min, Math.min(max, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------ header */
  function initHeader(ctx) {
    var bar = $('.bar', ctx); if (!bar || bar.__xrInit) return;
    bar.__xrInit = true;

    // Transparent over the home hero, surfaced once scrolled. Sub pages carry
    // .bar--floor from Liquid so they have a ground from the first pixel.
    var tick = function () {
      bar.classList.toggle('bar--solid', window.scrollY > window.innerHeight * 0.6);
      bar.classList.toggle('bar--compact', window.scrollY > 72);
    };
    addEventListener('scroll', tick, { passive: true }); tick();

    // Burger + phone menu. Closes on link, backdrop, Escape, and when the
    // window grows past the phone breakpoint.
    var burger = $('.bar__burger', bar);
    var menu = $('#menu');
    if (burger && menu) {
      var closeTimer = null;
      var openMenu = function () {
        clearTimeout(closeTimer);
        menu.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { menu.classList.add('menu--open'); }); });
        burger.setAttribute('aria-expanded', 'true');
        if (burger.dataset.labelClose) burger.setAttribute('aria-label', burger.dataset.labelClose);
        lock(true); bar.classList.add('bar--menu');
      };
      var closeMenu = function () {
        if (!menu.classList.contains('menu--open')) return;
        menu.classList.remove('menu--open');
        burger.setAttribute('aria-expanded', 'false');
        if (burger.dataset.labelOpen) burger.setAttribute('aria-label', burger.dataset.labelOpen);
        lock(false); bar.classList.remove('bar--menu');
        closeTimer = setTimeout(function () { menu.hidden = true; }, reduce ? 0 : 340);
      };
      burger.addEventListener('click', function () { menu.classList.contains('menu--open') ? closeMenu() : openMenu(); });
      menu.addEventListener('click', function (e) {
        var el = e.target.closest('[data-menu-close]'); if (!el) return;
        var href = el.getAttribute('href');
        closeMenu();
        var target = sameDocTarget(href);
        if (target) { e.preventDefault(); setTimeout(function () { target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, 80); }
      });
      addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('menu--open')) { closeMenu(); burger.focus(); } });
      addEventListener('resize', function () { if (window.innerWidth > 860) closeMenu(); });
    }

    // Mega menu: hover and focus, pointer devices only (the phone menu covers touch).
    var mega = $('.mega'), shopLink = $('.bar__nav a[data-mega]', bar);
    if (mega && shopLink && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var hideT;
      var show = function () { clearTimeout(hideT); mega.classList.add('mega--open'); shopLink.setAttribute('aria-expanded', 'true'); };
      var hide = function () { hideT = setTimeout(function () { mega.classList.remove('mega--open'); shopLink.setAttribute('aria-expanded', 'false'); }, 120); };
      shopLink.addEventListener('mouseenter', show); shopLink.addEventListener('mouseleave', hide);
      mega.addEventListener('mouseenter', show); mega.addEventListener('mouseleave', hide);
      shopLink.addEventListener('focus', show);
      mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget)) hide(); });
      addEventListener('keydown', function (e) { if (e.key === 'Escape' && mega.classList.contains('mega--open')) hide(); });
    }
  }

  /* ------------------------------------------------------------- search */
  function initSearch(ctx) {
    var search = $('.search', ctx); if (!search || search.__xrInit) return;
    search.__xrInit = true;
    var input = $('input[type="search"]', search), results = $('.search__results', search);
    var form = $('[data-search-form]', search);
    if (!input || !results) return;
    var defaults = results.innerHTML;
    var controller = null, lastFocus = null;

    var openSearch = function () {
      if (!search.hidden) return;
      lastFocus = document.activeElement;
      search.hidden = false;
      requestAnimationFrame(function () { search.classList.add('search--open'); input.focus(); input.select(); });
      lock(true);
      $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    };
    var closeSearch = function () {
      if (search.hidden) return;
      search.classList.remove('search--open'); lock(false);
      $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { search.hidden = true; }, reduce ? 0 : 240);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    var draw = debounce(function () {
      var q = input.value.trim();
      if (controller) controller.abort();
      if (q.length < 2) { results.innerHTML = defaults; return; }
      controller = new AbortController();
      var url = (H.routes.predictiveSearch || '/search/suggest') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('#shopify-section-predictive-search');
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function () {});
    }, 200);

    document.addEventListener('click', function (e) {
      if (!document.contains(search)) return;  // replaced by a section reload
      var o = e.target.closest('[data-search-open]');
      if (o) { e.preventDefault(); openSearch(); return; }
      if (search.contains(e.target) && e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    });
    input.addEventListener('input', draw);
    if (form) form.addEventListener('submit', function (e) {
      // Enter takes the first suggestion when there is one, else runs the full search.
      var first = $('.search__results .search__row', search);
      if (first && input.value.trim().length >= 2) { e.preventDefault(); first.click(); }
      else if (input.value.trim() === '') e.preventDefault();
    });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !search.hidden) { closeSearch(); return; }
      if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && search.hidden && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) { e.preventDefault(); openSearch(); }
    });
  }

  /* ------------------------------------------------------------ tab bar */
  // Hidden while the product buy bar is up (.buybar--on, owner C) and while
  // the reader scrolls down; back on the first upward move, at the top and
  // at the bottom. body.tab-hidden lets the gauge drop into the space.
  function initTabbar(ctx) {
    var tab = $('.tabbar', ctx); if (!tab || tab.__xrInit) return;
    tab.__xrInit = true;
    var here = location.pathname.replace(/\/$/, '') || '/';
    $$('a[href]', tab).forEach(function (a) {
      if (a.hasAttribute('data-cart-open') || a.hasAttribute('data-search-open') || a.hasAttribute('data-quiz-open')) return;
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
      if (u.origin === location.origin && !u.hash && (u.pathname.replace(/\/$/, '') || '/') === here) a.setAttribute('aria-current', 'page');
    });
    var buyOn = false, down = false, lastY = window.scrollY, run = 0;
    var applyTab = function () {
      var hide = buyOn || down;
      tab.classList.toggle('tabbar--hidden', hide);
      document.body.classList.toggle('tab-hidden', hide);
    };
    var syncBuy = function () {
      var bb = $('.buybar');
      var on = !!(bb && bb.classList.contains('buybar--on'));
      if (on !== buyOn) { buyOn = on; applyTab(); }
    };
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.nodeType === 1 && (t.classList.contains('buybar') || (list[i].type === 'childList'))) { syncBuy(); return; }
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
    syncBuy();
    addEventListener('scroll', function () {
      var y = window.scrollY, dy = y - lastY; lastY = y;
      if (document.body.classList.contains('menu-locked')) return;
      var max = root.scrollHeight - window.innerHeight;
      if (y < 80 || y > max - 40) { run = 0; if (down) { down = false; applyTab(); } return; }
      run = (dy > 0) === (run > 0) ? run + dy : dy;
      if (run > 28 && !down) { down = true; applyTab(); }
      else if (run < -14 && down) { down = false; applyTab(); }
    }, { passive: true });
  }

  /* ---------------------------------------------------- anchors + leave */
  // Same-document #anchor: smooth scroll, respects reduced motion.
  function sameDocTarget(href) {
    if (!href) return null;
    var u; try { u = new URL(href, location.href); } catch (x) { return null; }
    if (!u.hash || u.origin !== location.origin || u.pathname !== location.pathname) return null;
    var id = decodeURIComponent(u.hash.slice(1));
    return id ? document.getElementById(id) : null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]'); if (!a || e.defaultPrevented) return;
    if (a.closest('[data-menu-close]')) return;  // the phone menu handles its own
    var target = sameDocTarget(a.getAttribute('href')); if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + target.id);
  });

  // Page transitions: a veil rises from the bottom before an internal
  // navigation; the arriving page lifts its own veil (xred-scroll.js), so the
  // two read as one move. Off with the theme setting, reduced motion, and in
  // the theme editor.
  if (ON('transitions') && !reduce && !H.designMode) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]'); if (!a || e.defaultPrevented) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
      if (a.hasAttribute('data-cart-open') || a.hasAttribute('data-quiz-open') || a.hasAttribute('data-search-open')) return;
      var href = a.getAttribute('href'); if (!href || href.charAt(0) === '#') return;
      var u; try { u = new URL(href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin || !/^https?:$/.test(u.protocol)) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      e.preventDefault();
      var leave = document.createElement('div'); leave.className = 'leave'; document.body.appendChild(leave);
      requestAnimationFrame(function () { requestAnimationFrame(function () { leave.classList.add('leave--on'); }); });
      setTimeout(function () { location.href = u.href; }, 360);
    });
    addEventListener('pageshow', function (e) { if (e.persisted) $$('.leave').forEach(function (l) { l.remove(); }); });
  }

  /* --------------------------------------------------------------- quiz */
  function initQuiz(ctx) {
    var quiz = $('.quiz', ctx); if (!quiz || quiz.__xrInit) return;
    quiz.__xrInit = true;
    var Q = [];
    try { Q = JSON.parse(($('[data-quiz-questions]', quiz) || {}).textContent || '[]'); } catch (x) { Q = []; }
    var body = $('.quiz__body', quiz), prog = $('.quiz__prog i', quiz);
    var maxMild = +quiz.dataset.maxMild || 5, maxMid = +quiz.dataset.maxMid || 8, maxHot = +quiz.dataset.maxHot || 11;
    var step = 0, score = 0, smoke = 0, lastFocus = null;

    var openQuiz = function () {
      lastFocus = document.activeElement;
      step = 0; score = 0; smoke = 0;
      quiz.hidden = false;
      requestAnimationFrame(function () { quiz.classList.add('quiz--open'); });
      lock(true); ask();
      var c = $('[data-quiz-close].cart__close', quiz); if (c) c.focus();
    };
    var closeQuiz = function () {
      if (quiz.hidden) return;
      quiz.classList.remove('quiz--open'); lock(false);
      setTimeout(function () { quiz.hidden = true; }, reduce ? 0 : 240);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    var ask = function () {
      var s = Q[step]; if (!s) { result(); return; }
      if (prog) prog.style.transform = 'scaleX(' + (step / Q.length) + ')';
      body.innerHTML = '<p class="sc-label">' + esc(fill(quiz.dataset.stepLabel, { n: step + 1, total: Q.length })) + '</p>' +
        '<h3 class="sc-display sc-display--md">' + esc(s.q) + '</h3><div class="quiz__opts">' +
        s.a.map(function (o, i) { return '<button type="button" class="quiz__opt" data-v="' + (+o[1] || 0) + '" data-i="' + i + '">' + esc(o[0]) + '</button>'; }).join('') + '</div>';
      var first = $('.quiz__opt', body); if (first) first.focus();
    };
    var pick = function (key) {
      var order = { mild: ['mild', 'smoky', 'hot', 'extra'], smoky: ['smoky', 'hot', 'mild', 'extra'], hot: ['hot', 'smoky', 'extra', 'mild'], extra: ['extra', 'hot', 'smoky', 'mild'] }[key];
      for (var i = 0; i < order.length; i++) { var t = $('template[data-quiz-result="' + order[i] + '"]', quiz); if (t) return t; }
      return null;
    };
    var result = function () {
      var key = score <= maxMild ? 'mild' : score <= maxMid ? (smoke ? 'smoky' : 'hot') : score <= maxHot ? 'hot' : 'extra';
      var tpl = pick(key);
      if (!tpl) { closeQuiz(); return; }
      if (prog) prog.style.transform = 'scaleX(1)';
      body.innerHTML = '<p class="sc-label" style="color:' + esc(tpl.dataset.color || '') + '">' + esc(fill(quiz.dataset.resultEyebrow, { level: tpl.dataset.level || '' })) + '</p>';
      body.appendChild(tpl.content.cloneNode(true));
      var h = $('h3', body); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
    };
    quiz.addEventListener('click', function (e) {
      var o = e.target.closest('.quiz__opt');
      if (o) {
        score += +o.dataset.v || 0;
        if (Q[step] && +Q[step].smoky === +o.dataset.i) smoke = 1;
        step++;
        if (step < Q.length) ask(); else result();
        return;
      }
      if (e.target.closest('[data-quiz-again]')) { step = 0; score = 0; smoke = 0; ask(); return; }
      if (e.target.closest('[data-quiz-close]')) closeQuiz();
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quiz-open]'); if (!b || !document.contains(quiz)) return;
      e.preventDefault(); openQuiz();
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !quiz.hidden) closeQuiz(); });
  }

  /* --------------------------------------------------- localization */
  function initLocalization(ctx) {
    $$('form[data-localization-form]', ctx).forEach(function (form) {
      if (form.__xrInit) return; form.__xrInit = true;
      $$('select', form).forEach(function (sel) {
        sel.addEventListener('change', function () {
          var hidden = $('input[name="' + sel.dataset.target + '"]', form);
          if (hidden) hidden.value = sel.value;
          form.submit();
        });
      });
    });
  }

  /* ---------------------------------------------------------- share */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-copy]'); if (!btn) return;
    var input = $(btn.dataset.shareCopy);
    var url = input ? input.value : location.href;
    var done = function () { toast(btn.dataset.copied || 'Link copied'); };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {});
    else if (input) { input.select(); document.execCommand('copy'); done(); }
  });

  /* ------------------------------------------------------------ boot */
  // pages.css keys sub-page rules off body.page--sub (the static build set it
  // in HTML). Shopify's body only carries template-*; add it here.
  if (!document.body.classList.contains('template-index')) document.body.classList.add('page--sub');

  function init(ctx) {
    ctx = ctx || document;
    initHeader(ctx);
    initSearch(ctx);
    initTabbar(ctx);
    initQuiz(ctx);
    initProductForms(ctx);
    initLocalization(ctx);
  }
  H.init = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    // A re-rendered header or quiz is a new element: init it against the new tree.
    init(e.target);
    if (!document.body.classList.contains('template-index')) document.body.classList.add('page--sub');
  });
  document.addEventListener('shopify:section:unload', function () { lock(false); });
})();
